export { default } from "../../collection/[uid]/[pid]"
